// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_REMOVED_BUYERS = "Odstr\u00e1nen\u00ed z\u00e1ujemcovia";
export const BZ2_RESTORE_BUYER = "Obnov z\u00e1ujemcu";
